import { createSlice } from "@reduxjs/toolkit";
import { message } from "antd";
import { LoginUser } from "../../actions/auth-action/LoginAction";
import { LoginCognitoModel} from "../../../features/authentication/model";



interface LoginState {
    loading: boolean;
    loginmodel: LoginCognitoModel;
}

const initialLoginState: LoginState = {
    loading: false,
    loginmodel: {} as LoginCognitoModel
}
const LoginSlice = createSlice(
    {
        name: "login",
        initialState: initialLoginState,
        reducers: { reset: () => initialLoginState, },
        extraReducers: builder => {
            builder.addCase(LoginUser.fulfilled, (state: LoginState, { payload }) => {
                if (payload != null) {
                    state.loading = false;
                    message.success("Login Success");
                }
            });
            builder.addCase(LoginUser.pending, (state: LoginState, { payload }) => {
                state.loading = true;
                state.loginmodel = <LoginCognitoModel>{};
            })

            builder.addCase(LoginUser.rejected, (state: any, { payload }) => {
                state.loading = false;
                message.error("Login Failed");

            })
        }
    }

);


export default LoginSlice.reducer;